// store/modules/auth.js
import axios from "axios";
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
	namespaced: true,
	state: {
		user: null,
		isAuthenticated: false,
	},
	mutations: {
		SET_USER(state, user) {
			state.user = user;
			state.isAuthenticated = true;
		},
		LOGOUT(state) {
			state.user = null;
			state.isAuthenticated = false;
		},
	},
	actions: {
		async fetchCurrentUser({ commit }) {
			try {
				const response = await axios.get(`${API_BASE_URL}/current/profile`, {
					withCredentials: true,
				});
				commit("SET_USER", response.data.data);
				return true;
			} catch (err) {
				commit("LOGOUT");
				return false;
			}
		},
		async logout({ commit }) {
			try {
				await axios.post(`${API_BASE_URL}/logout`, null, {
					withCredentials: true,
				});
				commit("LOGOUT");
				return false;
			} catch (error) {
				commit("LOGOUT");
				return false;
			}
		},
	},
	getters: {
		userRole: (state) => state.user?.user_type,
		isAuthenticated: (state) => state.isAuthenticated,
	},
};
